class ShippingCutoff extends HTMLElement {
  connectedCallback() {
    this.cutoffHour   = parseInt(this.dataset.cutoffHour, 10);
    this.timezone     = this.dataset.cutoffTimezone;
    this.tzLabel      = this.dataset.cutoffTzLabel;
    this.skipWeekends = this.dataset.skipWeekends === 'true';

    // Economy
    this.economyBefore = parseInt(this.dataset.deliveryDaysBefore, 10);
    this.economyAfter  = parseInt(this.dataset.deliveryDaysAfter, 10);

    // Overnight
    this.overnightBefore = parseInt(this.dataset.overnightDaysBefore || 1, 10);
    this.overnightAfter  = parseInt(this.dataset.overnightDaysAfter  || 2, 10);

    this.messageEl = this.querySelector('[data-cutoff-message]');

    this.update();
    this.interval = setInterval(() => this.update(), 60_000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  update() {
    const nowInTz  = this.nowInTimezone();
    const cutoffTs = new Date(nowInTz);
    cutoffTs.setHours(this.cutoffHour, 0, 0, 0);

    const beforeCutoff = nowInTz < cutoffTs;

    const economyDays   = beforeCutoff ? this.economyBefore   : this.economyAfter;
    const overnightDays = beforeCutoff ? this.overnightBefore : this.overnightAfter;

    const economyDate   = this.addBusinessDays(nowInTz, economyDays);
    const overnightDate = this.addBusinessDays(nowInTz, overnightDays);

    const urgency = beforeCutoff
      ? `Order in <strong>${this.formatRemaining(cutoffTs - nowInTz)}</strong> — `
      : `Order today — `;

    this.messageEl.innerHTML =
      `${urgency}overnight by <strong>${this.formatDate(overnightDate)}</strong>, ` +
      `or free delivery by <strong>${this.formatDate(economyDate)}</strong>`;

    this.setAttribute('data-state', beforeCutoff ? 'before' : 'after');
  }

  nowInTimezone() {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: this.timezone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false,
    }).formatToParts(new Date());
    const get = t => parts.find(p => p.type === t).value;
    return new Date(
      `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`
    );
  }

  addBusinessDays(date, days) {
    const out = new Date(date);
    let added = 0;
    while (added < days) {
      out.setDate(out.getDate() + 1);
      const dow = out.getDay();
      if (!this.skipWeekends || (dow !== 0 && dow !== 6)) added++;
    }
    return out;
  }

  formatRemaining(ms) {
    const totalMin = Math.max(0, Math.floor(ms / 60_000));
    const h = Math.floor(totalMin / 60);
    const m = totalMin % 60;
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
  }

  formatDate(date) {
    return date.toLocaleDateString('en-US', {
      weekday: 'long', month: 'short', day: 'numeric',
    });
  }
}

if (!customElements.get('shipping-cutoff')) {
  customElements.define('shipping-cutoff', ShippingCutoff);
}